import styled, { css } from 'styled-components';
import { darken, lighten, desaturate, transparentize } from 'polished';
interface IContainerProps {
  $icon?: JSX.Element;
}
interface IInputProps {
  $error?: string;
  $icon?: JSX.Element;
}
export const Container = styled.div<IContainerProps>`
  margin-bottom: 0.5rem;
  padding: 0;
  display: flex;
  flex-direction: column;
  max-height: 59px;

  /* ICON ERROR */
  i {
    text-decoration: none;
    font-style: normal;
    color: ${props => props.theme.error};
    position: absolute;
    align-self: flex-end;
    padding: 0.65rem 0.6rem 0rem 0.6rem;
    svg {
      font-size: 0.875rem;
    }
  }

  /* ICON */
  ${props =>
    props.$icon &&
    css`
      > div {
        &:first-of-type {
          margin: 0.6rem;
          position: absolute;
          display: flex;
          align-self: flex-start;

          svg {
            stroke-width: 1px;
            font-size: 18px;
            color: ${props => props.theme.fontColor};
          }
          span {
            margin-left: 5px;
            border-right: 1px solid ${props => props.theme.fontColor};
            opacity: 0.3;
          }
        }
      }
    `}
  input[type="time"] {
    color: ${({ theme }) => theme.fontColor};
    -webkit-text-fill-color: ${({ theme }) => theme.fontColor};
    &::-webkit-calendar-picker-indicator {
      filter: ${({ theme }) => `invert(${theme.name === 'dark' ? 1 : 0})`};
      opacity: 1;
      cursor: pointer;
    }
  }
`;

export const Info = styled.div`
  caret-color: transparent;
  display: flex;
`;

export const RemainingChars = styled.span`
  margin-top: 1.5px;
  font-size: 0.75rem;
  color: ${props => props.theme.fontColor};
`;

export const ErrorMessage = styled.span`
  margin-top: 1.5px;
  align-self: flex-start;
  display: flex;
  flex: 1 1;
  flex-wrap: wrap;
  font-size: 0.75rem;
  color: ${props => props.theme.error};
`;

export const Input = styled.input<IInputProps>`
  border-radius: 4px;
  height: 38px;
  min-height: 38px;
  transition: border 0.3s ease;
  color: ${props => props.theme.fontColor};
  background: ${props =>
    props.theme.name === 'dark'
      ? lighten(0.05, props.theme.cardBackgroud)
      : darken(0.01, props.theme.cardBackgroud)};

  border: 1px solid ${props => props.theme.componentborder};
  ${({ $error }) =>
    $error &&
    css`
      border-color: ${props => props.theme.error};
    `}
  &:focus {
    border-color: ${props => desaturate(0.5, props.theme.button.primary.in)};
  }

  ${props =>
    props.$icon
      ? css`
          padding: 0 15px 0px 40px;
        `
      : css`
          padding: 0 15px;
        `}

  ${props =>
    props.$error &&
    css`
      padding: ${props.$icon ? '0 25px 0px 40px' : '0 15px'};
    `}

  &::placeholder {
    opacity: 0.6;
    color: ${props => props.theme.fontColor};
  }

  &:disabled {
    opacity: 0.8;
    color: ${props => transparentize(0.2, props.theme.fontColor)};
    cursor: not-allowed;
  }
`;
